import React from 'react'
import { Link } from 'react-router-dom'
import KarteraThemeSwitch from '../template/kartera/KarteraThemeSwitch'

const copy = {
    privacidad: {
        title: 'Aviso de privacidad',
        body: 'Kartera 365 trata los datos de tu agencia para operar la cartera de seguros. El aviso completo se publicará junto con el sitio de producto.',
    },
    terminos: {
        title: 'Términos y condiciones',
        body: 'El uso de Kartera 365 está sujeto a los términos del servicio. El documento legal completo se publicará junto con el sitio de producto.',
    },
}

const LegalPage = ({ kind }) => {
    const content = copy[kind] || copy.privacidad
    return (
        <div className="k-root min-h-dvh bg-k-bg px-[clamp(20px,4vw,48px)] py-8 font-kartera text-k-ink">
            <div className="mx-auto flex w-full max-w-[680px] flex-col gap-6">
                <div className="flex items-center justify-between gap-4">
                    <Link to="/login" className="text-sm font-bold text-k-accent-ink">Volver a iniciar sesión</Link>
                    <KarteraThemeSwitch compact />
                </div>
                <h1 className="m-0 text-[28px] font-extrabold tracking-[-0.03em]">{content.title}</h1>
                <p className="m-0 text-[15px] leading-[1.6] text-k-muted">{content.body}</p>
            </div>
        </div>
    )
}

export default LegalPage
